import * as THREE from '../client/three'

export const CHUNK_WIDTH = 16
export const CHUNK_HEIGHT = 128
export const CHUNK_DEPTH = 16

export const BLOCK_PIXELS = 32
export const PIXEL_SIZE = 1 / BLOCK_PIXELS

export const HALF_BLOCK = 0.5

export const REGION_SIZE = 6 // 6x6 chunks per region

export const MAX_LIGHT_LEVEL = 15

export const DIMMING_NORTH_SOUTH = 0.8
export const DIMMING_EAST_WEST = 0.6
export const DIMMING_UP = 1
export const DIMMING_DOWN = 0.4

export const DAY_LENGTH = 60 // seconds
export const DAY_LENGTH_SECONDS = 24 * 60 * 60 // 86,400. Leave as-is if "1.0 = 24h".

export const Directions = {
  all: [],
}
function addDirection(id, name, normal, axis, opposite, left, right) {
  const dir = {
    id,
    name,
    normal: new THREE.Vector3().fromArray(normal),
    axis,
    get opposite() {
      return Directions[opposite]
    },
    get left() {
      return Directions[left]
    },
    get right() {
      return Directions[right]
    },
  }
  Directions[name] = dir
  Directions[id] = dir
  Directions.all.push(dir)
}
addDirection(0, 'north', [0, 0, -1], 'z', 'south', 'west', 'east')
addDirection(1, 'east', [1, 0, 0], 'x', 'west', 'north', 'south')
addDirection(2, 'south', [0, 0, 1], 'z', 'north', 'east', 'west')
addDirection(3, 'west', [-1, 0, 0], 'x', 'east', 'south', 'north')
addDirection(4, 'up', [0, 1, 0], 'y', 'down', null, null)
addDirection(5, 'down', [0, -1, 0], 'y', 'up', null, null)

// export function blockToIdx(x, y, z) {
//   return x + CHUNK_WIDTH * (y + CHUNK_HEIGHT * z)
// }

// export function positionToChunk(x, y, z) {
//   const chunkX = Math.floor(x / CHUNK_WIDTH)
//   const chunkZ = Math.floor(z / CHUNK_DEPTH)
//   return [chunkX, chunkZ]
// }

// export function positionToChunkId(x, y, z) {
//   const chunkX = Math.floor(x / CHUNK_WIDTH)
//   const chunkZ = Math.floor(z / CHUNK_DEPTH)
//   return `${chunkX}_${chunkZ}`
// }

// y-major layout: y fastest, then x, then z
// stores data in vertical block columns contiguously
// good for RLE
export function getVoxelIdx(x, y, z) {
  return y + CHUNK_HEIGHT * (x + CHUNK_WIDTH * z)
}

const _arr = []
export function idxToVoxel(idx) {
  const y = idx % CHUNK_HEIGHT
  const temp = Math.floor(idx / CHUNK_HEIGHT)
  const x = temp % CHUNK_WIDTH
  const z = Math.floor(temp / CHUNK_WIDTH)
  _arr[0] = x
  _arr[1] = y
  _arr[2] = z
  return _arr
}

// Converts [r, g, b] values (0–255) to a hex color string
function blockLightPartToHex(v) {
  // Expect v in range 0–255
  return Math.round(v).toString(16).padStart(2, '0')
}

export function blockLightToHex([r, g, b]) {
  return `#${blockLightPartToHex(r)}${blockLightPartToHex(g)}${blockLightPartToHex(b)}`
}

// Converts a hex color string to a [r, g, b] array (values 0–255)
export function hexToBlockLight(hex) {
  // Remove '#' if present
  hex = hex.replace(/^#/, '')
  if (hex.length === 3) {
    // expand shorthand form (#f00 → #ff0000)
    hex = hex
      .split('')
      .map(ch => ch + ch)
      .join('')
  }

  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)

  return [r, g, b]
}

const rgbsMask = 0xf

// bitpacked integer to [r,g,b,s]
// export function lightToArray(light) {
//   const r = (light >>> 12) & rgbsMask
//   const g = (light >>> 8) & rgbsMask
//   const b = (light >>> 4) & rgbsMask
//   const s = light & rgbsMask
//   return [r, g, b, s]
// }

// [r,g,b,s] to bitpacked integer
// export function arrayToLight([r, g, b, s]) {
//   return ((r & rgbsMask) << 12) | ((g & rgbsMask) << 8) | ((b & rgbsMask) << 4) | (s & rgbsMask)
// }

// applis a dimming factor to light
export function dimLight(light, dimmingFactor) {
  const l = []
  l[0] = light[0] * dimmingFactor
  l[1] = light[1] * dimmingFactor
  l[2] = light[2] * dimmingFactor
  l[3] = light[3] * dimmingFactor
  return l
}
